<template>
  <div>
    <!-- <el-button
      type="text"
      @click="dialogTableVisible = true"
    >点击打开 Message Box</el-button> -->
    <div  @click="dialogTableVisible = true" class="alertBg"></div>
    <el-dialog
      :visible.sync="dialogTableVisible"
      :lockScroll='false'
    >
      <video-player
        class="video-player vjs-custom-skin myvideo"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
      ></video-player>
    </el-dialog>

  </div>
</template>


<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      // 视频播放
      playerOptions: {
        playbackRates: [1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://cdn1.zygames.com/qqsm/video/cn-lrly.mp4" //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  methods: {
    onPlayerPlay(player) {
    },
    onPlayerPause(player) {
    }
  },
  components: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    dialogTableVisible() {}
  },
  watch: {
    dialogTableVisible(val) {
      if (!val) {
        this.$refs.videoPlayer.player.pause();//关闭弹窗暂停
        this.$refs.videoPlayer.player.src(this.playerOptions.sources[0].src);// 重置进度条
      }
    }
  }
};
</script>


<style scoped>
.alertBg{
    width: 79px;
    height: 69px;
    background: url('../assets/img/radio-o1.png') no-repeat top center;
    cursor: pointer;
}
</style>


<style>
.el-dialog .el-dialog__header {
  padding: 0;
}
.el-dialog .el-dialog__body {
  padding: 0;
}

.el-dialog .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: -62px;
  /* border: 2px solid #ccc; */
  width: 60px;
  height: 60px;
}
.el-dialog .el-dialog__headerbtn > i {
  font-size: 60px;
  line-height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/videoPlayer.vue